import { createSelector } from "@reduxjs/toolkit";
import { createStructuredSelector } from "reselect";
import { Selectors as ProfileSelectors } from "./profile";
import { Selectors as ServiceSelectors } from "./services";
import { Selectors as ReviewSelectors } from "@/store/reviews/selectors";
import { formatMinutes } from "@/utils/time";
import { OPENING_HOURS_DAYS_SPECIFICATION } from "@/misc/constants";

const getOpeningHoursSpecification = createSelector(
  ProfileSelectors.getWeekSchedule,
  (schedule) => {
    return schedule
      .map(({ opening_hours }, idx) => ({
        "@type": "OpeningHoursSpecification",
        opens: formatMinutes(opening_hours[0]),
        closes: formatMinutes(opening_hours[1]),
        dayOfWeek: OPENING_HOURS_DAYS_SPECIFICATION[idx],
      }))
      .filter(({ closes }) => closes !== "00:00");
  }
);

const getPricingStartsFrom = (state) =>
  ServiceSelectors.getCheapestService(state)?.price.amount || 0;
const getAvatarAltText = (state) => {
  const name = ProfileSelectors.getFullName(state);
  if(!name) return "";
  return "pro-" + name.replace(/\s+/g, "-") + "-in-lakki-crm";
}
const getPortfolioDefaultAltText = createSelector(ServiceSelectors.getUniqueSpecs, (specs) => {
  return "portfolio-" + specs.map((s) => s.replace(/\s/g, "-")).join("-") + "-in-lakki-crm";
})


const getSeoMeta = createStructuredSelector({
  name: ProfileSelectors.getFullName,
  specs: ServiceSelectors.getStringifiedSpecs,
  city: ProfileSelectors.getCity,
  pricingStartsFrom: getPricingStartsFrom,
  reviews: ReviewSelectors.getReviews,
  services: ServiceSelectors.getServices,
  masterId: ProfileSelectors.getMasterId,
  coords: ProfileSelectors.getCoords,
  address: ProfileSelectors.getHrAddress,
  rate: ProfileSelectors.getRate,
  reviewsCount: ProfileSelectors.getReviewsCount,
  workingHours: getOpeningHoursSpecification,
});
export const Selectors = {
  getSeoMeta,
  getAvatarAltText,
  getPortfolioDefaultAltText,
};
